<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="800">
    <v-form ref="form" class="white px-11 py-10">
      <v-row class="pb-7">
        <v-col cols="11">
          <p class="form__title mb-0 gray--text">
            OBJETO DO SEGURO
          </p>
        </v-col>
        <v-col cols="1" class="text-end pb-5">
          <BaseButton text icon @click="closeModal" class="justify-end">
            <v-icon size="17" color="gray" class="justify-end">
              fa-times
            </v-icon>
          </BaseButton>
        </v-col>
        <v-col cols="12">
          <BaseFormTextArea
            id-element="reasonCancelEndorsement"
            placeholder="Inserir"
            v-model="form.comentario"
            :rules="[requiredInput, maxLengthTextArea]"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="3">
          <BaseButton
            @click="submit"
            class="secondary"
            width="100%"
            v-html="'SALVAR'"
          />
        </v-col>
      </v-row>
    </v-form>
  </v-dialog>
</template>
<script>
import { requiredInput, maxLengthTextArea } from "@/utils/rules.js";
export default {
  data: () => ({
    errorMessages: [],
    requiredInput,
    maxLengthTextArea
  }),
  methods: {
    closeModal() {
      this.$emit("close");
    },
    submit() {
      if (this.validate()) this.$emit("submit");
    },
    validate() {
      this.errorMessages = this.form.comentario
        ? []
        : ["É preciso fazer um comentário no objeto do seguro"];
      return this.form.comentario;
    }
  },
  props: {
    form: {
      type: Object
    }
  }
};
</script>
